import { createFileRoute, redirect } from '@tanstack/react-router';
import { CustomerManagement } from '../components/CustomerManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/customer')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: CustomerSettingsComponent,
});

function CustomerSettingsComponent() {
  return <CustomerManagement />;
}
